/* erx-desk.js - OmniPRO 2.0 page (sections/erx-desk-*.liquid). Ships with assets/erx-desk.css.
   Runs AFTER assets/erx-chair.js, the shared PDP script (gallery, Sau / Įmonei, tier maths, bars, tab bar,
   FAQ, lightbox, loops). This file only adds what the desk needs on top:
   1. three option pickers (frame colour x top x size) -> one variant, handed to erx-chair.js;
   2. the live technical-drawings section moved into the collapsed "Techninės savybės" panel;
   3. feature loops start on the frame their poster shows. */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------------- 1. option pickers ---------------- */
  const initPicker = () => {
    const top = $('[data-erx-dk-top]'), dataEl = $('#erx-ch-data');
    if (!top || !dataEl) return;
    let data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    const variants = data.variants || [], names = data.names || {};
    const input = $('#variant-id-input');
    const current = () => variants.find(v => String(v.id) === String(input && input.value)) || variants[0];
    const find = (f, t, s) => variants.find(v => v.f === f && v.t === t && v.s === s);
    const targetFor = (v, key, val) => {
      const want = { f: v.f, t: v.t, s: v.s };
      want[key] = val;
      return find(want.f, want.t, want.s);
    };
    const sync = () => {
      const v = current();
      if (!v) return;
      /* packshot scale follows the size (erx-desk.css): the 140 and 160 tables fill more of their canvas */
      top.dataset.erxSize = v.s;
      $$('[data-erx-opt]', top).forEach(b => {
        const key = b.dataset.erxOpt, val = b.dataset.erxVal, on = v[key] === val;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        /* only a size is greyed for the exact combination; a frame or top stays live while ANY size of it
           (with the current other colour) is in stock, so one sold-out size never greys the colours */
        const t = targetFor(v, key, val);
        const na = key === 's'
          ? !t || t.available === false
          : !variants.some(x => x[key] === val && x[key === 'f' ? 't' : 'f'] === v[key === 'f' ? 't' : 'f'] && x.available !== false);
        b.classList.toggle('is-na', na);
      });
      $$('[data-erx-oname]', top).forEach(el => {
        const key = el.dataset.erxOname, n = (names[key] || {})[v[key]] || v[key] || '';
        el.textContent = el.dataset.fmt ? el.dataset.fmt.replace('[size]', n) : n;
      });
      /* the live technical-drawings section reads this for its first paint */
      const full = (window.productVariantsData || []).find(x => String(x.id) === String(v.id));
      if (full) window.selectedOptions = { option1: full.option1, option2: full.option2, option3: full.option3 };
    };
    top.addEventListener('click', e => {
      const b = e.target.closest('[data-erx-opt]');
      if (!b || !top.erxSelect) return;
      const v = current(), key = b.dataset.erxOpt, val = b.dataset.erxVal;
      if (!v || v[key] === val) return;
      /* exact combination if it is in stock; a colour whose current size is sold out moves to a size that
         is in stock; then any variant with the picked value */
      const exact = targetFor(v, key, val);
      const other = key === 'f' ? 't' : 'f';
      const t = (exact && exact.available !== false ? exact : null)
        || (key !== 's' ? variants.find(x => x[key] === val && x[other] === v[other] && x.available !== false) : null)
        || exact
        || variants.find(x => x[key] === val && x.available !== false)
        || variants.find(x => x[key] === val);
      if (t) top.erxSelect(t.id);
    });
    top.addEventListener('erx:variant', sync);
    sync();
    /* the rating under the name links to the Loox reviews (#looxReviews, audit 2026-10-12); erx-chair.js scrolls there */
  };

  /* ---------------- 2. "Techninės savybės": the live section becomes the panel content ---------------- */
  const initSpecs = () => {
    const slot = $('[data-erx-dk-tech-slot]'), tech = document.getElementById('omnipro2-technical');
    if (!slot || !tech) return;
    slot.appendChild(tech.closest('.ergonix-wrapper') || tech);
  };

  /* ---------------- 3. loops start where their poster is ---------------- */
  const initStarts = () => {
    $$('video[data-erx-start]').forEach(v => {
      const t = parseFloat(v.dataset.erxStart);
      if (!(t > 0)) return;
      v.addEventListener('loadedmetadata', () => { try { if (t < v.duration) v.currentTime = t; } catch (e) {} }, { once: true });
    });
  };

  const init = () => { initPicker(); initSpecs(); initStarts(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
